import { useDrag } from 'react-dnd';
import {
  IDndLayoutComponentDragObject as IDragObject,
  IDndLayoutComponentDropResult as IDropResult,
} from './DndLayoutComponents.types';

export function useDragLayoutComponent<CollectedProps = unknown>(
  ...args: Parameters<typeof useDrag<IDragObject, IDropResult, CollectedProps>>
) {
  return useDrag(...args);
}
